module.exports = __webpack_public_path__ + "img/popup-entry-bg-1.2c482f42.png";